import styled from 'styled-components';

export const TWrapper = styled.span`
  border: 1.5px solid #d3aa3b;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0px 1px 6px 0px rgba(27, 27, 27, 0.05);
`;
